import { compose } from 'recompose';

import CategoriesList from './CategoriesList';

const enhance = compose();

export default enhance(CategoriesList);
